import { LayoutGrid, Briefcase, Calendar, Inbox, User, TrendingUp, Users, MessageSquare, Building2, UserPlus, ChevronRight, Home, FileText, BookmarkIcon, Bell, Settings } from 'lucide-react';

export const getMenuItems = (userRole) => {
  const menuConfigs = {
    jobSeeker: [
      {
        id: 'dashboard',
        icon: LayoutGrid,
        label: 'Dashboard Home',
        path: '/dashboard',
        exact: true
      },
      {
        id: 'jobs',
        icon: Briefcase,
        label: 'Jobs',
        path: '/dashboard/jobs'
      },
      {
        id: 'interviews',
        icon: Calendar,
        label: 'Interviews & Calendar',
        path: '/dashboard/interviews'
      },
      {
        id: 'inbox',
        icon: Inbox,
        label: 'Inbox',
        path: '/dashboard/inbox',
        badge: 8
      },
      {
        id: 'profile',
        icon: User,
        label: 'Profile & Settings',
        path: '/dashboard/profile'
      },
      {
        id: 'insights',
        icon: TrendingUp,
        label: 'Career Insights',
        path: '/dashboard/insights'
      }
    ],
    employer: [
      {
        id: 'dashboard',
        icon: LayoutGrid,
        label: 'Dashboard Home',
        path: '/employer-dashboard',
        exact: true
      },
      {
        id: 'jobs',
        icon: Briefcase,
        label: 'Jobs',
        expandable: true,
        chevronIcon: ChevronRight,
        subItems: [
          { id: 'active', label: 'Active Postings', path: '/employer-dashboard/jobs/active', badge: 5 },
          { id: 'draft', label: 'Draft Jobs', path: '/employer-dashboard/jobs/draft', badge: 2 },
          { id: 'archived', label: 'Archived', path: '/employer-dashboard/jobs/archived' },
          { id: 'analytics', label: 'Analytics', path: '/employer-dashboard/jobs/analytics' }
        ]
      },
      {
        id: 'candidates',
        icon: Users,
        label: 'Candidates',
        expandable: true,
        chevronIcon: ChevronRight,
        subItems: [
          { id: 'pipeline', label: 'Pipeline', path: '/employer-dashboard/candidates/pipeline', badge: 12 },
          { id: 'shortlisted', label: 'Shortlisted', path: '/employer-dashboard/candidates/shortlisted', badge: 3 },
          { id: 'interviews', label: 'Interview Scheduling', path: '/employer-dashboard/candidates/interviews' }
        ]
      },
      {
        id: 'messages',
        icon: MessageSquare,
        label: 'Messages',
        path: '/employer-dashboard/messages',
        badge: 7
      },
      {
        id: 'company',
        icon: Building2,
        label: 'Company Profile',
        path: '/employer-dashboard/company'
      },
      {
        id: 'team',
        icon: UserPlus,
        label: 'Team Management',
        path: '/employer-dashboard/team'
      }
    ]
  };

  return menuConfigs?.[userRole] || menuConfigs?.jobSeeker;
};

export const jobSeekerMenu = [
  { icon: Home, label: 'Overview', path: '/dashboard' },
  { icon: Briefcase, label: 'Jobs', path: '/dashboard/jobs' },
  { icon: BookmarkIcon, label: 'Saved Jobs', path: '/dashboard/saved-jobs' },
  { icon: FileText, label: 'Applications', path: '/dashboard/applications' },
  { icon: MessageSquare, label: 'Messages', path: '/dashboard/messages' },
  { icon: Calendar, label: 'Interviews', path: '/dashboard/interviews' },
  { icon: Bell, label: 'Notifications', path: '/dashboard/notifications' },
  { icon: User, label: 'Profile', path: '/dashboard/profile' },
];